// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Qaa-z","narrowOptionButtons":"Raa-z","noOptions":"Saa-z"};